import * as Dialog from '@radix-ui/react-dialog';
import styled from 'styled-components';

export const Root = styled(Dialog.Root)``;

export const Portal = styled(Dialog.Portal)``;

export const Overlay = styled(Dialog.Overlay)`
	z-index: 99;
	background-color: rgba(0, 0, 0, 0.35);
	position: fixed;
	inset: 0;
	animation: overlayShow 150ms cubic-bezier(0.16, 1, 0.3, 1);

	@keyframes overlayShow {
		from {
			opacity: 0;
		}
		to {
			opacity: 1;
		}
	}
`;

export const Content = styled(Dialog.Content)`
	display: flex;
	flex-direction: column;
	gap: 12px;
	z-index: 100;
	background-color: ${({ theme }) => theme.gray[0]};
	border-radius: 3px;
	box-shadow: hsl(206 22% 7% / 35%) 0px 10px 38px -10px, hsl(206 22% 7% / 20%) 0px 10px 20px -15px;
	position: fixed;
	width: 90vw;
	max-width: 500px;
	max-height: 95vh;
	padding: 20px;
	animation: contentShow 150ms cubic-bezier(0.16, 1, 0.3, 1);

	&:focus {
		outline: none;
	}

	/* Mobile-specific styles */
	&[data-mobile='true'] {
		width: calc(100vw - 32px);
		max-width: calc(100vw - 32px);
		max-height: calc(100vh - 32px);
		padding: 24px;
		border-radius: 12px;
		gap: 16px;
	}

	@keyframes contentShow {
		from {
			opacity: 0;
			transform: translate(-50%, -48%) scale(0.96);
		}
		to {
			opacity: 1;
			transform: translate(-50%, -50%) scale(1);
		}
	}
`;

export const Title = styled(Dialog.Title)`
	font-weight: 500;
	color: ${({ theme }) => theme.gray['1000']};
	font-size: 16px;
	margin: 0px;

	/* Larger text on mobile for better readability */
	[data-mobile='true'] & {
		font-size: 18px;
	}
`;

export const Description = styled(Dialog.Description)`
	color: ${({ theme }) => theme.gray['1000']};
	font-size: 13px;
	margin: 0px;
	line-height: 1.2;

	/* Larger text on mobile for better readability */
	[data-mobile='true'] & {
		font-size: 15px;
		line-height: 1.4;
	}
`;
